import {styled, useMediaQuery} from "@mui/system";
import {Box, Button} from "@mui/material";
import Base from "../../../../../../../components/base";
import {buildPath, scale} from "../../../../../../../utils";
import BaseTitle from "../../../../../../../components/base/title";
import React, {useEffect, useState} from "react";
import {ESITO_PRENOTAZIONE} from "../../../../../../../constants/images";
import theme, {FONTS} from "../../../../../../../constants/theme";
import Text from "../../../../../../../components/text";
import { Email, Phone } from "@mui/icons-material";
import ThemedText from "../../../../../../../components/text";
import {useLocation, useNavigate, useParams} from "react-router-dom";


const Wrapper = styled(Box)({

})

const ContentWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: "center",
  gap: scale(10),
  height: scale(39 + 78 + 89),
  marginTop: scale(20),
  [theme.breakpoints.down('sm')]: {
    width: '100vw',
    height: scale(264),
    flexDirection: 'column',
    minWidth: scale(200),
    maxWidth: scale(530),
    fontSize: scale(18),
    alignItems: 'center',
    backgroundColor: theme.palette.primary.main,
    borderRadius: scale(20),
    gap: scale(20),
    marginTop: scale(20),
    paddingTop: scale(10),
    paddingBottom: scale(10),
  },
})

const ContactWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: "center",
  gap: scale(0),
  height: scale(89),
})

const ButtonGroup = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  columnGap: scale(11),
  marginTop: scale(10),

});

const ThemedButton = styled(Button)({
  borderRadius: scale(30),
  width: scale(224),
  height: scale(52),
  marginTop: scale(13),
  boxShadow: 'none',
  '&:hover': {
    boxShadow: 'none',
  },
  '&.Mui-disabled': {
    backgroundColor: theme.palette.lightGray.main,
    cursor: 'not-allowed',
  },
  [theme.breakpoints.down('sm')]: {
    width: scale(214),
    height: scale(52),
    marginBottom: scale(16),
  }
});

const EsitoPrenotazione = () => {
  const navigate = useNavigate();
  const { raccoltaId } = useParams<{ raccoltaId: string }>();
  const [success, setSuccess] = useState<{status: boolean | 'conflict', message?: string} | null>(null);
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const location = useLocation();
  const path = location.pathname;

  const isOperatore = path.includes('operatore');

  useEffect(() => {
    const result = sessionStorage.getItem('newDonorResult');
    if (result) {
      const parsed = JSON.parse(result);
      setSuccess(parsed);
    }
    else {
      navigate(buildPath('/operatore/calendario'))
    }
  }, [navigate])

  if (success === null) {
    return null;
  }

  return (
    <Wrapper>
      <Base style={{ height: isMobile ? 'auto' : scale(900), width: isMobile ? undefined : scale(900)}}>
        <BaseTitle
          title={success.status === true ? (isOperatore ? 'Donatore aggiunto' : 'Prenotazione Effettuata') : 'Prenotazione non riuscita'}
          sx={{
            marginTop: scale(62),
            minHeight: scale(100),
            width: isMobile ? '100vw' : '100%',
            backgroundColor: success.status === true ? theme.palette.green.main : theme.palette.blood.main,
            [theme.breakpoints.down('sm')]: {
              marginTop: 0,
              minHeight: success.status === true ?scale(110): scale(180),
              paddingTop: scale(20),
              justifyContent: 'center',
              backgroundColor: success.status === true ? theme.palette.green.main : theme.palette.blood.main,
              '& > span': {
                color: theme.palette.text.primary,
              },
            },
          }}
        />
      {
        success.status === 'conflict' ? 
            <Box
              sx={{
                position: 'relative',
                marginTop: scale(5),
                width: scale(900),
                height: isMobile ? scale(310) : scale(360),
                backgroundColor: theme.palette.blood.main,
                backgroundSize: '165%',
                backgroundPosition: `${scale(-580)} ${scale(0)}`,
                backgroundRepeat: 'no-repeat',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
                gap: scale(30),
                color: 'white',
                textAlign: 'center',
              }}
        >
              <Text
              text={`Risulti già prenotato con questo\n numero di telefono per la raccolta\n del ${success.message ?? ''}.`}
              fontFamily={FONTS.MONTSERRAT}
              fontSize={scale(28)}
              lineHeight={scale(39)}
              sx={{ textAlign: 'center' }}
              color={theme.palette.text.primary}           
              />
              <Text
              text={'Se desideri cambiare la tua\n prenotazione contattaci.'}
              sx={{ textAlign: 'center' }}
              fontSize={scale(32)}
              fontWeight={'bold'}
              lineHeight={scale(39)}
              fontFamily={FONTS.MONTSERRAT}
              minHeight={scale(110)}
              />
              </Box>
            :
             <Box
                sx={{
                  position: 'relative',
                  width: scale(900),
                  height: isMobile ? scale(310) : scale(360),
                  backgroundImage: `url(${ESITO_PRENOTAZIONE})`,
                  backgroundSize: '165%',
                  backgroundPosition: `${scale(-580)} ${scale(0)}`,
                  backgroundRepeat: 'no-repeat',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'white',
                  textAlign: 'center',
                }}
        >
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              zIndex: 1,
            }}
          />

          <Box
            sx={{
              position: 'relative',
              zIndex: 2,
              width: scale(900),
              height: scale(360),
              gap: scale(2),
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Text
              text={'Donazione di sangue:'}
              fontFamily={FONTS.MONTSERRAT}
              color={theme.palette.text.primary}
              fontSize={scale(32)}
              fontWeight={'bold'}
              lineHeight={scale(39)}
              sx={{ textAlign: 'center' }}
            />
            <Text
              text={'10 minuti che valgono una vita.'}
              fontFamily={FONTS.MONTSERRAT}
              color={theme.palette.text.primary}
              fontSize={scale(32)}
              fontWeight={'bold'}
              lineHeight={scale(39)}
              sx={{ textAlign: 'center' }}
            />
            <Text
              text={'Il contributo di ogni singolo donatore \n è indispensabile per la vita,\n per la salute, per tutti.'}
              fontFamily={FONTS.MONTSERRAT}
              color={theme.palette.text.primary}
              fontSize={scale(28)}
              fontWeight={400}
              lineHeight={scale(39)}
              sx={{ textAlign: 'center' }}
            />
            <Text
              text={'GRAZIE!'}
              fontFamily={FONTS.MONTSERRAT}
              color={theme.palette.text.primary}
              fontSize={scale(32)}
              fontWeight={'bold'}
              lineHeight={scale(39)}
              sx={{ textAlign: 'center' }}
            />
          </Box>
        </Box>
        }
        <ContentWrapper>
          <Text
            text={'ATTENZIONE'}
            fontFamily={FONTS.MONTSERRAT}
            color={isMobile ? theme.palette.text.primary : theme.palette.text.secondary}
            fontSize={scale(32)}
            fontWeight={'bold'}
            lineHeight={scale(39)}
            sx={{ textAlign: 'center' }}
          />
          <Text
            text={'Per informazioni o modifiche\n a prenotazioni contattaci.'}
            fontFamily={FONTS.MONTSERRAT}
            color={isMobile ? theme.palette.text.primary : theme.palette.ceramic.contrastText}
            fontSize={scale(24)}
            fontWeight={400}
            lineHeight={scale(29)}
            sx={{ textAlign: 'center' }}
          />
          <ContactWrapper>
            <a
              href="https://www.aviscomunalegenova.it/"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: isMobile ? theme.palette.text.primary : theme.palette.ceramic.contrastText,
                fontWeight: 500,
                fontSize: isMobile ? scale(22) : scale(24),
                fontFamily: FONTS.MONTSERRAT,
                textDecoration: "underline",
                lineHeight: scale(30),
              }}
            >
              AVIS Comunale Genova
            </a>
            <Box
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 1,
                color: isMobile ? theme.palette.text.primary : 'primary.main',
              }}
            >
              <Phone sx={{ fontSize: 20 }} />
              <Text
                text={'+39 010 355861 | 3292345449'}
                fontFamily={FONTS.MONTSERRAT}
                color={isMobile ? theme.palette.text.primary : theme.palette.ceramic.contrastText}
                fontSize={scale(24)}
                fontWeight={500}
                lineHeight={scale(30)}
                sx={{ textAlign: 'center' }}
              />
            </Box>
            <Box
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 1,
                color: isMobile ? theme.palette.text.primary : 'primary.main',
              }}
            >
              <Email sx={{ fontSize: 20 }} />
              <Text
                text={'genova.comunale@avis.it'}
                fontFamily={FONTS.MONTSERRAT}
                color={isMobile ? theme.palette.text.primary : theme.palette.ceramic.contrastText}
                fontSize={scale(24)}
                fontWeight={500}
                lineHeight={scale(30)}
                sx={{ textAlign: 'center' }}
              />
            </Box>
          </ContactWrapper>
        </ContentWrapper>
        <ButtonGroup>
          {isOperatore && (<ThemedButton
            variant="contained"
            onClick={() => {
              sessionStorage.removeItem('newDonorInfo')
              sessionStorage.removeItem('newDonorResult')
              navigate(buildPath('/operatore/dettaglio-raccolta/' + raccoltaId));
            }}>
            <ThemedText text={'vai a raccolta'} fontWeight={600} fontSize={scale(18)} fontFamily={FONTS.MONTSERRAT}/>
          </ThemedButton>)}
          <ThemedButton
            variant="contained"
            onClick={() => {
              sessionStorage.removeItem('newDonorInfo')
              sessionStorage.removeItem('newDonorResult')
              navigate(buildPath(isOperatore ? '/operatore/calendario' : '/donatore/'));
            }}
          >
            <ThemedText text={isOperatore ? 'vai a calendario' : 'home'} fontWeight={600} fontSize={scale(18)} fontFamily={FONTS.MONTSERRAT} sx={{textWrap: 'nowrap'}}/>
          </ThemedButton>
        </ButtonGroup>
      </Base>
    </Wrapper>
  )
}

export default EsitoPrenotazione;
